import React from "react";
import "./myPatientsViewHeader.scss";
import { Link } from "react-router-dom";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";

const MyPatientsViewHeader = (props) => {
  const { patientName } = props;

  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );

  // Display UI ===>

  const displayMyPatientsViewHeader = () => {
    return (
      <div className="mypatients-view-header">
        <div className="mypatients-view-header-title">{patientName}</div>
        <div className="mypatients-view-header-goback">
          <Link
            to={{
              pathname:
                doctorClinicAssociation === "true" ||
                staffClinicAssociation === "true"
                  ? "/clinic/account/mypatients"
                  : "/doctor/account/mypatients",
            }}
          >
            <div className="mypatients-view-header-goback-btn">
              {"< Go Back"}
            </div>
          </Link>
        </div>
      </div>
    );
  };

  // <===

  return <>{displayMyPatientsViewHeader()}</>;
};

export default MyPatientsViewHeader;
